// Configuration of API URLs based on the environment variable
let backendUrl; let llmUrl; let
  frontendUrl;

switch (process.env.NEXT_PUBLIC_ENV) {
  case 'development':
    backendUrl = 'http://127.0.0.1:8080';
    llmUrl = 'http://127.0.0.1:8081';
    frontendUrl = 'http://localhost:3000';
    console.log('DEV environment detected');
    break;
  case 'staging':
    backendUrl = 'https://backend-staging-vdpwsf4viq-uc.a.run.app';
    llmUrl = 'https://llms-staging-vdpwsf4viq-uc.a.run.app';
    frontendUrl = 'https://app.reachpathways.com';
    console.log('STAGING environment detected');

    break;
  case 'production':
    backendUrl = 'https://backend-vdpwsf4viq-uc.a.run.app';
    llmUrl = 'https://llms-vdpwsf4viq-uc.a.run.app';
    frontendUrl = 'https://app.reachpathways.com';
    console.log('PROD environment detected');
    break;
  default:
    // Default to staging if ENV is not set
    backendUrl = 'https://backend-staging-vdpwsf4viq-uc.a.run.app';
    llmUrl = 'https://llms-staging-vdpwsf4viq-uc.a.run.app';
    frontendUrl = 'http://localhost:3000';
    console.warn('ENV not set, defaulting to STAGING');
}

// Export these constants so they can be used throughout your application
export const BACKEND_URL = backendUrl;
export const LLM_URL = llmUrl;
export const FRONTEND_URL = frontendUrl;
